export default __webpack_public_path__ + "static/media/power_serv.e81c54d5.jpg";